import React from "react";
import Button from "./Button";

const QuantityInput = ({ value, onChange, min = 0, max = 99 }) => {
  const handleDecrease = () => {
    if (value > min) onChange(value - 1);
  };

  const handleIncrease = () => {
    if (value < max) onChange(value + 1);
  };

  return (
    <div className="flex items-center justify-between bg-[#232222] rounded-full w-[100px] h-9 text-white px-1">
      <Button
        buttonFunction={handleDecrease}
        buttonClasses="
          flex items-center justify-center w-7 h-7 bg-white rounded-full
          text-black text-lg font-Medium transition active:scale-95 hover:bg-white
        "
        buttonLabel="−"
        buttonLabelClasses="leading-none text-2xl"
      />

      <span className="text-base font-normal text-white text-center select-none">
        {value}
      </span>

      <Button
        buttonFunction={handleIncrease}
        buttonClasses="
          flex items-center justify-center w-7 h-7 bg-white rounded-full
          text-black text-lg font-Medium transition active:scale-95 hover:bg-white
        "
        buttonLabel="+"
        buttonLabelClasses="leading-none text-2xl"
      />
    </div>
  );
};

export default QuantityInput;
